// extracted by mini-css-extract-plugin
export default {"searchPlaces":"SearchPlaces_searchPlaces__OzTZ9"};